import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/compat/database';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { FileUpload } from './fileupload';
import { LoggingService } from 'src/app/shared/services/Logging.service';
import { NotificationService } from 'src/app/shared/services/notification.service';



@Injectable({
  providedIn: 'root'
})
export class UploadFileService {

  constructor(private loggingService: LoggingService,private db: AngularFireDatabase, private storage: AngularFireStorage,private http:HttpClient,
    private notificationService: NotificationService) { }

  pushFileToStorage(fileUpload: FileUpload,basePath) {
    var url=""
    const storageRef = this.storage.ref(basePath);
    const uploadTask = this.storage.upload(basePath, fileUpload.file);
    uploadTask.snapshotChanges().pipe(
      finalize(() => {
        storageRef.getDownloadURL().subscribe(downloadURL => {
          this.loggingService.log("downloadURL",downloadURL)
          fileUpload.url = downloadURL;
          fileUpload.name = fileUpload.file.name;
          //this.saveFileData(fileUpload,basePath);
        });
      })
    ).subscribe();
    return url
  }
  private saveFileData(fileUpload: FileUpload,basePath): void {
    this.db.list(basePath).push(fileUpload);
  }

  getFiles(numberItems,basePath): AngularFireList<FileUpload> {
    return this.db.list(basePath, ref =>
      ref.limitToLast(numberItems));
  }
  deleteFile(fileUpload: FileUpload,basePath): void {
    this.deleteFileDatabase(fileUpload.key,basePath)
      .then(() => {
        this.deleteFileStorage(fileUpload.name,basePath);
      })
      .catch(error => { console.log('Something went wrong'); this.loggingService.log(error); });
  }
  private deleteFileDatabase(key: string,basePath): Promise<void> {
    return this.db.list(basePath).remove(key);
  }
  private deleteFileStorage(name: string,basePath): void {
    const storageRef = this.storage.ref(basePath);
    storageRef.child(name).delete();
  }

  read(url){
    this.http.get(url, {responseType: "json"}).subscribe(
      (data) => {
        this.loggingService.log("data",data)
      })
  }
}
